import Cookies from "js-cookie";

const SetXsrfHeader = (headers: Record<string, string>): void => {
	const token = Cookies.get("xsrf_token");
	if (!token) { return; }
	headers["xsrf_token"] = token;
}

const Fetch = async (url: string, requestOptions: any): Promise<any> => {
	SetXsrfHeader(requestOptions.headers);
	let response = await fetch(url, requestOptions);
	if (response.status === 200) {
		return response.json();
	}
	if (response.status === 204) {
		return;
	}
	let textError = "";
	let jsonError = {};
	try {
		textError = await response.text();
		jsonError = JSON.parse(textError);
	} catch (e) {
		console.error(e);
		throw { message: `Unexpected error occured (Status: ${response.status}). ` + textError };
	}
	throw jsonError;
}

const FetchWithTimeout = async (url: string, requestOptions: any, timeoutMs: number): Promise<any> => {
	const controller = new AbortController();
	const id = setTimeout(() => controller.abort(), timeoutMs);
	
	try {
		const response = await Fetch(url, {
			...requestOptions,
			signal: controller.signal,
		});
		clearTimeout(id);
	
		return response;
	} catch (e) {
		if (controller.signal.aborted) {
			throw { message: `Request timed out after ${timeoutMs/1000}s.` };
		}
		throw e;
	}
}

export async function Post<TBody, TResult>(url: string, body: TBody, timeoutMs?: number): Promise<TResult> {
	const requestOptions = {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(body),
	};
	if (timeoutMs) {
		return await FetchWithTimeout(url, requestOptions, timeoutMs);
	}
	return await Fetch(url, requestOptions);
}

export async function PostForm<TResult>(url: string, body: FormData): Promise<any> {
	const requestOptions = {
		method: "POST",
		body: body,
		headers: {},
	}
	SetXsrfHeader(requestOptions.headers);
	const response = await fetch(url, requestOptions);
	if (response.status === 200) {
		return await response.json();
	}
	if (response.status === 204) {
		return;
	}
	throw await response.json();
}

export async function Get<TResult>(url: string): Promise<TResult> {
	const requestOptions = {
		method: "GET",
		headers: { "Content-Type": "application/json" },
	}
	return await FetchWithTimeout(url, requestOptions, 10000);
}